module.exports = {
          srcSet: __webpack_public_path__ + "df4f4a0cb6d75b0b9cd891f12a2fd4f5-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "df4f4a0cb6d75b0b9cd891f12a2fd4f5-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "df4f4a0cb6d75b0b9cd891f12a2fd4f5-120.png",
          toString:function(){return __webpack_public_path__ + "df4f4a0cb6d75b0b9cd891f12a2fd4f5-120.png"},
          
          width: 120,
          height: 120
        }